import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import ThumbsUpIcon from '@nv/images/design/thumbs-up-icon'
import { useTranslation } from 'react-i18next'
import styles from './SuccessDownloaded.module.scss'

export const SuccessDownloaded = () => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('main.downloaded'))
    setBtns([{ text: t('buttons.ok'), onClick: onClose }])
  }, [])

  return (
    <div className={styles['container']}>
      <ThumbsUpIcon color={'var(--success-color)'} />
      <span className={styles['label']}> {t('main.thankyou')}</span>
      <span className={styles['subtitle']}>{t('admin.electorsList.downloadSuccess')}</span>
    </div>
  )
}
